module.exports = __webpack_public_path__ + "img/thumbs_down.63661093.gif";